export const navigationSelector = state => ({
  isTransitionedToCoachView: state.navigation.isTransitionedToCoachView,
});
